// extracted by mini-css-extract-plugin
module.exports =  {"root":"ViewController-module__root--hjWOx","spacer":"ViewController-module__spacer--o6Hqx","clearAll":"ViewController-module__clearAll--Kyt9I"};